module.exports = __webpack_public_path__ + "static/media/image_30.9b5a0062.png";